import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "webins-step-conferma" }
const _hoisted_2 = {
  key: 0,
  class: "box-review center"
}
const _hoisted_3 = {
  key: 1,
  class: "box-review center"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Inserire la mail associata all'acquisto per procedere alla visualizzazione", -1)
const _hoisted_6 = ["onKeyup"]
const _hoisted_7 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 0,
  class: "box-review"
}
const _hoisted_13 = {
  key: 0,
  class: "center"
}
const _hoisted_14 = {
  key: 1,
  class: "center"
}
const _hoisted_15 = { style: {"font-size":"18px","text-align":"center"} }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Abbiamo inviato un’email con il dettaglio della polizza a ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "box-review" }
const _hoisted_19 = { class: "reservation-main-data" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("small", null, "Inizio Viaggio", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("small", null, "Fine Viaggio", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("small", null, "Destinazione", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("small", null, "Viaggiatori", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = { class: "box-review reservation-items" }
const _hoisted_29 = { class: "box-review" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h3", null, "Viaggiatori", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Nome"),
    /*#__PURE__*/_createElementVNode("th", null, "Data di Nascita")
  ])
], -1)
const _hoisted_32 = {
  key: 3,
  class: "box-review box-failure"
}

import { computed, ref, onMounted } from "vue";
import { useI18n } from 'vue-i18n';
import dayjs from "dayjs";
import Loading from "../../loading.vue";
import ReservationItems from "../pagamento/reservationItems.vue";
import PayPalButton from "../pagamento/paypalButton.vue";
import { useReservation, usePolizze, useWidget } from "@/composables";
import { Pax } from "@/models";



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const { reservation, loadReservation } = useReservation();


const { loading, parametriPreventivatore, totali, rigaCarrelloDati, transazione, adesioneCreata, numberToCurrency, 
  downloadCertificato, guidAdesioneSearch, caricaAdesione, msgAddToCart } = usePolizze();
const { destinazioniPreventivatore, widgetConfig, isPaymentInternal } = useWidget();

const existingEmail = ref("");
const invalidMail = ref("");
const nascondiContraente = ref<boolean>(false);

onMounted(() => {
  nascondiContraente.value = widgetConfig.value && widgetConfig.value.nascondiContraente ? true : false;
  if(guidAdesioneSearch.value && !chiediEmailConferma.value ){
    getAdesioneSearch();
  }
});



const partecipanti = computed( () => {
  adesioneCreata.value.datiAdesione.partecipantiElencoLista
  //var p = rigaCarrelloDati.value.datiCarrello.elencoPartecipanti ? JSON.parse( atob( rigaCarrelloDati.value.datiCarrello.elencoPartecipanti)) : [];
  var p = adesioneCreata.value.datiAdesione.partecipantiElencoLista;
  for(var i = 0; i < p.length; i++)
    //p[i].dataNascita && (p[i].dataNascita = dayjs(p[i].dataNascita ).format("DD/MM/YYYY"));
    p[i].dataNascita && ( (p[i].dataNascita as unknown ) = dayjs(p[i].dataNascita ).format("DD/MM/YYYY"));
  return p;
});


/*
const getReservation = async () => {
  invalidMail.value = "";
  const loaded = await loadReservation(existingReservationId.value, existingEmail.value);
  if(loaded == false) {
    invalidMail.value = "Nessuna prenotazione disponibile associata alla mail specificata..";
  }
}*/

const getAdesioneSearch = async () => {
  invalidMail.value = "";
  const adesioneCaricata = await caricaAdesione(guidAdesioneSearch.value, existingEmail.value);
  if(!adesioneCaricata) {
    invalidMail.value = chiediEmailConferma.value ? "Nessuna polizza disponibile associata alla mail specificata.." : "Polizza non trovata";
  }
}



const scaricaCertificato = async() => {
  await downloadCertificato(adesioneCreata.value.guidAdesione);
}

const state = computed(() => {
  if(guidAdesioneSearch.value ) {
    if(!adesioneCreata.value) {
      return "search";
    }
    else {
      return "review";
    }
  }
  else if( !isPaymentInternal.value) {
    return "addToCart";
  }
  else {
    return "confirm";
  }
});

const chiediEmailConferma = computed(() => {
    return widgetConfig.value && widgetConfig.value.chiediEmailSuRecuperoAdesione ? true : false;
});

const partecipantiPerFascia = computed(() => {
    if( !parametriPreventivatore.value.fasceEta || !parametriPreventivatore.value.fasceEta.length )
        return [];

    var p = []
    for( var i = 0; i < parametriPreventivatore.value.fasceEta.length; i++){
        if(parametriPreventivatore.value.fasceEta[i].numeroPartecipanti )
            p.push(parametriPreventivatore.value.fasceEta[i]);
    }
    return p;
});

const inizioViaggio = computed(() => {
    if (adesioneCreata.value.datiAdesione.inizioViaggio != null) {
        return dayjs(adesioneCreata.value.datiAdesione.inizioViaggio).format(t("common.dateUIFormat") || "DD/MM/YYYY");
    }
    return "?";
});

const fineViaggio = computed(() => {
    if (adesioneCreata.value.datiAdesione.fineViaggio != null) {
        return dayjs(adesioneCreata.value.datiAdesione.fineViaggio).format(t("common.dateUIFormat") || "DD/MM/YYYY");
    }
    return "?";
});

const destinazioneNome = computed(() => {
    if (adesioneCreata.value.datiAdesione.destinazioneID != null) {
        var d = destinazioniPreventivatore.value.find((a) => a.value === adesioneCreata.value.datiAdesione.destinazioneID);
        return d && d.text ? d.text : "-";
    }
    return "-";
});



const taken = computed(() => {
  /*if(reservation.value.dateTimeTaken != null) {        
    return dayjs(reservation.value.dateTimeTaken).format(t("common.dateTimeUIFormat"));
  }
  return dayjs().format(t("common.dateTimeUIFormat"))*/
  return "";
});

const getPaxName = (pax: Pax) => {
  let name = "";

  if(pax.firstName != null && pax.firstName.length > 0) {
    name += pax.firstName;
  }

  if(pax.lastName != null && pax.lastName.length > 0) {
    if(name.length > 0) {
      name += " ";
    }
    name += pax.firstName;
  }

  if(name.length == 0) {
    name = "not specified";
  }

  return name;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(state) == 'addToCart')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h3", null, _toDisplayString(_unref(msgAddToCart) || 'La polizza è stata aggiunta al carrello'), 1)
          ]))
        : (_unref(state) == 'search')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_unref(chiediEmailConferma))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _hoisted_5,
                    _withDirectives(_createElementVNode("input", {
                      class: "email-validation",
                      type: "email",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((existingEmail).value = $event)),
                      placeholder: "email",
                      onKeyup: _withKeys(getAdesioneSearch, ["enter"])
                    }, null, 40, _hoisted_6), [
                      [_vModelText, existingEmail.value]
                    ]),
                    (invalidMail.value.length > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(invalidMail.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn",
                      onClick: getAdesioneSearch
                    }, "Mostra acquisto")
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (invalidMail.value.length > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(invalidMail.value), 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_10, "Recupero pratica in corso"))
                  ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_unref(state) == 'confirm')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_unref(widgetConfig).isWondersafe)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_13, " Grazie per aver assicurato il tuo viaggio con Wondersafe "))
                      : (_openBlock(), _createElementBlock("h1", _hoisted_14, " Grazie per aver assicurato il tuo viaggio ")),
                    _createElementVNode("h2", _hoisted_15, [
                      _hoisted_16,
                      _hoisted_17,
                      _createTextVNode(_toDisplayString(_unref(adesioneCreata).datiAderente.email), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", { class: "box-review d-flex justify-content-center" }, [
                _createElementVNode("button", {
                  class: "btn",
                  style: {"font-size":"18px","text-align":"center"},
                  onClick: scaricaCertificato
                }, "Scarica il certificato assicurativo")
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", null, [
                    _hoisted_20,
                    _hoisted_21,
                    _createElementVNode("strong", null, _toDisplayString(_unref(inizioViaggio)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_22,
                    _hoisted_23,
                    _createElementVNode("strong", null, _toDisplayString(_unref(fineViaggio)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_24,
                    _hoisted_25,
                    _createElementVNode("strong", null, _toDisplayString(_unref(destinazioneNome)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_26,
                    _hoisted_27,
                    _createElementVNode("strong", null, _toDisplayString(_unref(adesioneCreata).datiAdesione.numeroPartecipanti), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(ReservationItems, {
                  enableDetailButton: false,
                  showMainMedia: false,
                  enableDel: false
                })
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("table", null, [
                  _hoisted_31,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(partecipanti), (pax) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: pax.itemID
                      }, [
                        _createElementVNode("td", null, _toDisplayString(pax.nome + ' ' + pax.cognome), 1),
                        _createElementVNode("td", null, _toDisplayString(pax.dataNascita || '-'), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])),
      (_unref(transazione) && (_unref(transazione).adesioniErrori && _unref(transazione).adesioniErrori.length ))
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transazione).adesioniErrori, (err, index) => {
              return (_openBlock(), _createElementBlock("p", { key: index }, [
                _createElementVNode("strong", null, _toDisplayString(err.descrizione), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Loading, { isloading: _unref(loading) }, null, 8, ["isloading"])
  ], 64))
}
}

})